// Full-document render of the tempurpedic UtilityPageWithToolbox: PageSkeleton
// (the React document shell) wrapping the `#utility-page-with-toolbox` body.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { UtilityPageWithToolboxBody } from "../components/UtilityPageWithToolboxBody";

type IProps = templates.UtilityPageWithToolboxTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div id="utility-page-with-toolbox">
                <UtilityPageWithToolboxBody
                    page={props.page}
                    hardcoded_ssr={props.hardcoded_ssr}
                    hotspot_ssr={props.hotspot_ssr}
                    breadcrumbs_ssr={props.breadcrumbs_ssr}
                    customer_service_ssr={props.customer_service_ssr}
                    shop_compare_ssr={props.shop_compare_ssr}
                    tab_feature_attribute_ssr={props.tab_feature_attribute_ssr}
                    reviews_ssr={props.reviews_ssr}
                />
            </div>
        </PageSkeleton>
    );
};
